'use client'

import classNames from 'classnames';

import { OfferCard } from './OfferCard';
import { ITopOffersData } from './types';
import { Button } from '@/components/atoms';
import { useMemo, useState } from 'react';
import { NoDataView } from '../NoDataView';

interface TopOffersProps {
    data?: ITopOffersData;
}

const TopOffers: React.FC<TopOffersProps> = ({ data }) => {
    const [loadMore, setLoadMore] = useState(false);

    const offers = useMemo(() => {
        if (!loadMore) {
            return data?.offers?.slice(0, 5) || [];
        }
        return data?.offers || [];
    }, [data, loadMore]);

    const isTopOffer = (index: number) => {
        return index < 5;
    }

    if (data?.error) {
        return <div className="py-5 px-10 text-center text-red-500">Error: {data.error}</div>;
    }


    if (!offers.length) {
        return (
            <NoDataView />
        )
    }


    return (
        <section className={classNames('w-full', 'bg-white', 'rounded-lg', 'p-6', 'font-roboto')}>
            <div
                className={classNames(
                    'grid',
                    'grid-cols-[repeat(auto-fit,minmax(220px,1fr))]',
                    'items-stretch',
                    'w-full',
                    'gap-4',
                    // 'font-rajdhani'
                )}
            >
                {offers.map((offer, index) => (
                        <OfferCard
                            key={offer.offerId}
                            topOffer={isTopOffer(index)}
                            offerId={offer.offerId}
                            title={offer.title}
                            description={offer.description}
                            impressions={offer.impressions}
                            claims={offer.claims}
                            image={offer.image}
                        />
                ))}
            </div>
            {
                (data?.offers ?? []).length > 5 && (
                    <div className="flex justify-center pt-5">
                        <Button
                            variant='light'
                            onClick={() => setLoadMore(prev => !prev)}
                        >
                            {loadMore ? 'Show less' : 'Load more'}
                        </Button>
                    </div>
                )
            }
        </section>
    );
}

export { TopOffers }